export class Localizacao {
    logradouro: string = ''
    numero: string = ''
    logradouroComNumero: string = ''
    municipio: string = ''
    municipioIdentificador: string = ''
    uf: string = ''
    endereco: string = ''
}